import { PersonStatusEnum } from 'types/person'

const WORKING_STATUSES = new Set<string>([
  PersonStatusEnum.FULL_TIME,
  PersonStatusEnum.PART_TIME,
])

const TERMINATED_STATUSES = new Set<string>([
  PersonStatusEnum.TERMINATED,
  PersonStatusEnum.TERMINATED_NO_COBRA,
])

export function isTerminatedStatus(status: string | null | undefined): boolean {
  return TERMINATED_STATUSES.has(status ?? '')
}

export function isWorkingStatus(status: string | null | undefined): boolean {
  return WORKING_STATUSES.has(status ?? '')
}

export function shouldAskForRehireDate(
  previousStatus: string | null | undefined,
  nextStatus: string | null | undefined
): boolean {
  return isTerminatedStatus(previousStatus) && isWorkingStatus(nextStatus)
}

export function shouldSyncRehire(
  previousStatus: string | null | undefined,
  nextStatus: string | null | undefined,
  previousRehireDate: string | null | undefined,
  nextRehireDate: string | null | undefined
): boolean {
  const rehireChanged = (previousRehireDate ?? '') !== (nextRehireDate ?? '')
  return rehireChanged || shouldAskForRehireDate(previousStatus, nextStatus)
}

/** A failed rehire-date write still syncs a return to Full-Time or Part-Time. */
export function shouldSyncAfterRehireSave(
  previousStatus: string | null | undefined,
  nextStatus: string | null | undefined,
  previousRehireDate: string | null | undefined,
  nextRehireDate: string | null | undefined,
  rehireSaveFailed: boolean
): boolean {
  if (rehireSaveFailed) {
    return shouldAskForRehireDate(previousStatus, nextStatus)
  }
  return shouldSyncRehire(
    previousStatus,
    nextStatus,
    previousRehireDate,
    nextRehireDate
  )
}
